import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectStamps} from '~/CreateFabricInvitation/reducers/fabricTemplate/selectors';
import {
  UPDATE_DESIGN_OPTIONS,
  RESET_DESIGN_OPTIONS,
} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {
  selectStampId,
  selectHasStampIdChanged,
} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';

export const useStamp = () => {
  const dispatch = useDispatch();
  const stamps = useSelector(selectStamps);
  const stampId = useSelector(selectStampId);
  const hasStampChanged = useSelector(selectHasStampIdChanged);

  const onStampReset = useCallback(() => {
    dispatch({
      type: RESET_DESIGN_OPTIONS,
      payload: ['stampId'],
    });
  }, []);

  const onStampChange = useCallback(
    (image) => {
      const selected = stamps?.find(
        ({media}) => media.find(({label}) => label === 'image').url === image
      );
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {stampId: selected?.id, premiumFeaturesPristine: false},
      });
    },
    [stamps, stampId]
  );

  const stampIcons = useMemo(
    () => stamps?.map(({media}) => media.find(({label}) => label === 'image').url),
    [stamps]
  );

  const selectedStamp = useMemo(() => {
    const selected =
      stamps?.find(({id}) => id === stampId) || stamps?.find(({id}) => id === 'evite-stamp-black');

    if (selected) {
      const image = selected.media.find(({label}) => label === 'image').url;
      return {...selected, image};
    }

    return null;
  }, [stamps, stampId]);

  return {stampIcons, onStampChange, onStampReset, selectedStamp, hasStampChanged};
};
